import React from 'react';
import PropTypes from 'prop-types';

function ISFacebookV2({ to, className }) {
  return (
    <a className={className} target={`_blank`} rel="noopener noreferrer" href={to}>
      <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8822_114002)">
          <path d="M19.5834 10.6234C19.5834 5.29837 15.2928 0.981548 10 0.981548C4.70729 0.981548 0.416687 5.29837 0.416687 10.6234C0.416687 15.4359 3.92115 19.4249 8.50262 20.1482V13.4106H6.06936V10.6234H8.50262V8.49922C8.50262 6.08272 9.93339 4.74792 12.1224 4.74792C13.1706 4.74792 14.2676 4.93623 14.2676 4.93623V7.30904H13.0592C11.8688 7.30904 11.4974 8.05234 11.4974 8.81559V10.6234H14.1553L13.7304 13.4106H11.4974V20.1482C16.0789 19.4249 19.5834 15.4359 19.5834 10.6234Z" fill="#5A5A5A"/>
        </g>
        <defs>
          <clipPath id="clip0_8822_114002">
            <rect width="20" height="20" fill="white" transform="translate(0 0.56488)"/>
          </clipPath>
        </defs>
      </svg>
    </a>
  )
}

ISFacebookV2.propTypes = {
  to: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default ISFacebookV2;
